import(/* webpackMode: "eager" */ "E:\\AjayWork\\Orange_Tiger_Nextjs\\node_modules\\next\\dist\\client\\image-component.js");
;
import(/* webpackMode: "eager" */ "E:\\AjayWork\\Orange_Tiger_Nextjs\\node_modules\\next\\dist\\client\\script.js");
;
import(/* webpackMode: "eager" */ "E:\\AjayWork\\Orange_Tiger_Nextjs\\node_modules\\next\\font\\google\\target.css?{\"path\":\"src\\\\app\\\\layout.js\",\"import\":\"Montserrat\",\"arguments\":[{\"subsets\":[\"latin\"],\"variable\":\"--font-montserrat\"}],\"variableName\":\"montserrat\"}");
;
import(/* webpackMode: "eager" */ "E:\\AjayWork\\Orange_Tiger_Nextjs\\node_modules\\next\\font\\google\\target.css?{\"path\":\"src\\\\app\\\\layout.js\",\"import\":\"Open_Sans\",\"arguments\":[{\"subsets\":[\"latin\"],\"variable\":\"--font-open-sans\"}],\"variableName\":\"openSans\"}");
;
import(/* webpackMode: "eager" */ "E:\\AjayWork\\Orange_Tiger_Nextjs\\node_modules\\bootstrap\\dist\\css\\bootstrap.min.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "E:\\AjayWork\\Orange_Tiger_Nextjs\\src\\app\\ClientChunkErrorHandler.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "E:\\AjayWork\\Orange_Tiger_Nextjs\\src\\app\\GlobalErrorHandler.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "E:\\AjayWork\\Orange_Tiger_Nextjs\\src\\components\\AOSInitializer.js");
;
import(/* webpackMode: "eager", webpackExports: ["FormProvider"] */ "E:\\AjayWork\\Orange_Tiger_Nextjs\\src\\components\\FormContext.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "E:\\AjayWork\\Orange_Tiger_Nextjs\\src\\components\\ImportBS\\page.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "E:\\AjayWork\\Orange_Tiger_Nextjs\\src\\components\\TigerLoader.js");
;
import(/* webpackMode: "eager" */ "E:\\AjayWork\\Orange_Tiger_Nextjs\\src\\styles\\globals.css");
;
import(/* webpackMode: "eager" */ "E:\\AjayWork\\Orange_Tiger_Nextjs\\src\\styles\\custom.css");
;
import(/* webpackMode: "eager" */ "E:\\AjayWork\\Orange_Tiger_Nextjs\\src\\styles\\responsive.css");
